
export default {
  locationTargeting: "استهداف الموقع",
  selectTargetedLocations: "حدد المواقع المستهدفة",
  devicesPerLocation: "الأجهزة لكل موقع",
  locationSelection: "اختيار المواقع",
  campaignDuration: "مدة الحملة",
  numberOfScreens: "عدد الشاشات",
  days: "أيام",
  day: "يوم",
  total: "المجموع",
  devices: "الأجهزة",
  duration: "المدة",
  mediaOwnerSpecificContent: "محتوى مخصص لكل مالك وسيلة إعلانية",
  noMediaOwnersAvailable: "لا توجد مالكين وسائل إعلانية متاحة",
  wakiReviewWarning: "تحتاج واكي إلى فترة 5 أيام لمراجعة مواد الإعلان قبل النشر.",
  selectAllIn: "تحديد الكل في",
  toggleAll: "تبديل الكل",
  // Region names
  allRegions: "جميع المناطق",
  riyadh: "الرياض",
  jeddah: "جدة", 
  easternProvince: "المنطقة الشرقية",
  medina: "المدينة المنورة",
  alKharj: "الخرج",
  dawadmi: "الدوادمي",
  tabuk: "تبوك",
  hail: "حائل",
  hafarAlBatin: "حفر الباطن",
  majmaa: "المجمعة",
  qassim: "القصيم",
  sakaka: "سكاكا",
  arar: "عرعر",
  alQurayyat: "القريات",
  alJubail: "الجبيل",
  yanbu: "ينبع",
  khamisMushait: "خميس مشيط",
  sabia: "صبيا",
  abha: "أبها",
  jizan: "جازان",
  najran: "نجران",
  muhayil: "محايل",
  alBahah: "الباحة",
  
  // Device map filters
  mediaOwner: "مالك الوسائط",
  mediaType: "نوع الوسائط",
  all: "الكل",
  indoor: "داخلي",
  outdoor: "خارجي",
  
  // Map popup translations
  screens: "وجوه",
  viewReferenceImage: "عرض الصورة المرجعية",
  locationReferenceImage: "الصورة المرجعية للموقع",
  outdoorLedDisplay: "شاشة LED خارجية سلسلة البلاتينيوم:",
  pixelSizes: "أحجام البكسل 10 مم",
  highBrightness: "سطوع عالي: SMD 10000nits",
  cost: "التكلفة",
  locationType: "نوع الموقع",
  availableFaces: "الوجوه المتاحة",
  screenSize: "حجم الشاشة",
  gender: "الجنس",
  ageRange: "الفئة العمرية",
  orientation: "الاتجاه",
  segment: "الشريحة",
  schoolType: "نوع المدرسة",
  educationLevel: "المستوى التعليمي",
  students: "الطلاب",
  description: "الوصف",
  removeLocation: "إزالة الموقع",
  bookScreens: "حجز الشاشات",
  deselectLocation: "إلغاء تحديد الموقع",
  selectLocation: "تحديد الموقع",
  screenSelection: "اختيار الوجوه",
  screensToBook: "الوجوه المراد حجزها",
  screen: "وجه",
  selectExactScreens: "حدد بدقة عدد الوجوه التي تحتاجها",
  
  // Price and dynamic content
  sarPerScreenPerDay: "ريال سعودي لكل شاشة يومياً",
  sarPerFacePerDay: "ريال سعودي لكل وجه يومياً",
  price: "السعر",
  
  // Location types that might appear in data
  digitalBridgeScreen: "شاشة الجسر الرقمية",
  outdoorBillboard: "لوحة إعلانية خارجية",
  
  // Common values that might appear
  male: "ذكور",
  female: "إناث",
  mixed: "مختلط",
  landscape: "أفقي",
  portrait: "عمودي",
  
  // Date selection mode
  dateRange: "نطاق التواريخ",
  specificDates: "تواريخ محددة",
  selectSpecificDates: "حدد التواريخ المحددة لحملتك",
  datesSelected: "تاريخ محدد",
  clearAll: "مسح الكل",
  selectAllMonth: "تحديد الكل"
} as const;
